import React from "react";
import Routes from "./Routes";
import { HomePageSchema } from "./components/SchemaMarkup";

import "./App.scss";
import "./assets/scss/theme.scss";

const App = (pageProps) => {
  return (
    <div className="App">
      <HomePageSchema />
      <Routes childProps={pageProps} />
    </div>
  );
};

export default App;
